import Vue from 'vue';

// Dedicated event bus for MAV streaming window communication
export const MavStreamBus = new Vue();
